module.exports = __webpack_public_path__ + "img/custom-software-color.be270389.png";